import { NavbarLogoBlack, NavbarLogoWhite } from "@brg/ui";
import { FC } from "react";
import {LogoWrapper, LogoWrapperWhite} from "../style";

export const NavbarBlackOrWhite: FC <any> = (props) => {
    const { theme } = props;

    if (theme === 'white') {
        return (
            <LogoWrapperWhite className={'LogoWrapperWhite'} isOpen={props.isOpen} isKiiidsArt={props.isKiidsArt}>
                <NavbarLogoWhite
                    {...props}
                />
            </LogoWrapperWhite>
        )
    }

    return (
        <LogoWrapper>
            <NavbarLogoBlack 
                {...props}
            />
        </LogoWrapper>
    )
}import { NavbarLogoBlack, NavbarLogoWhite } from "@brg/ui";
import { FC } from "react";
import {LogoWrapper, LogoWrapperWhite} from "../style";

export const NavbarBlackOrWhite: FC <any> = (props) => {
    const { theme } = props;

    if (theme === 'white') {
        return (
            <LogoWrapperWhite className={'LogoWrapperWhite'} isOpen={props.isOpen} isKiiidsArt={props.isKiidsArt}>
                <NavbarLogoWhite
                    {...props}
                />
            </LogoWrapperWhite>
        )
    }

    return (
        <LogoWrapper>
            <NavbarLogoBlack 
                {...props}
            />
        </LogoWrapper>
    )
}